import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useDocumentTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const updateTitleAndFavicon = (pathname) => {
      let title = 'Fe en Juego';
      let faviconPath = '/images/fe-en-juego-favicon.png'; // Default favicon
      
      // Check if we're in the conectados game
      if (pathname.startsWith('/conectados')) {
        title = 'Conecta2';
        faviconPath = '/images/conectados-favicon.jpg'; // Conecta2 favicon
      }
      
      // Update title
      document.title = title;
      
      // Update favicon
      // Remove existing favicon links
      const existingLinks = document.querySelectorAll("link[rel*='icon']");
      existingLinks.forEach(link => link.remove());
      
      // Create new favicon link
      const link = document.createElement('link');
      link.type = 'image/png';
      link.rel = 'icon';
      link.href = faviconPath;
      document.getElementsByTagName('head')[0].appendChild(link);
    };

    updateTitleAndFavicon(location.pathname);
  }, [location.pathname]);
};

export default useDocumentTitle;
